/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { processQueryApiV1ChatQueryPost } from '../fn/chat/process-query-api-v-1-chat-query-post';
import { ProcessQueryApiV1ChatQueryPost$Params } from '../fn/chat/process-query-api-v-1-chat-query-post';
import { streamQueryApiV1ChatQueryStreamPost } from '../fn/chat/stream-query-api-v-1-chat-query-stream-post';
import { StreamQueryApiV1ChatQueryStreamPost$Params } from '../fn/chat/stream-query-api-v-1-chat-query-stream-post';
import { SystemResponse } from '../models/system-response';
import { StreamEvent } from '../models/stream-event';

@Injectable({ providedIn: 'root' })
export class ChatService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `processQueryApiV1ChatQueryPost()` */
  static readonly ProcessQueryApiV1ChatQueryPostPath = '/api/v1/chat/query';

  /**
   * Process Query.
   *
   * Process a query through Julia AI system
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `processQueryApiV1ChatQueryPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  processQueryApiV1ChatQueryPost$Response(params: ProcessQueryApiV1ChatQueryPost$Params, context?: HttpContext): Observable<StrictHttpResponse<SystemResponse>> {
    return processQueryApiV1ChatQueryPost(this.http, this.rootUrl, params, context);
  }

  /**
   * Process Query.
   *
   * Process a query through Julia AI system
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `processQueryApiV1ChatQueryPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  processQueryApiV1ChatQueryPost(params: ProcessQueryApiV1ChatQueryPost$Params, context?: HttpContext): Observable<SystemResponse> {
    return this.processQueryApiV1ChatQueryPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<SystemResponse>): SystemResponse => r.body)
    );
  }

  /** Path part for operation `streamQueryApiV1ChatQueryStreamPost()` */
  static readonly StreamQueryApiV1ChatQueryStreamPostPath = '/api/v1/chat/query/stream';

  /**
   * Stream Query.
   *
   * Stream query processing for real-time feedback
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `streamQueryApiV1ChatQueryStreamPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  streamQueryApiV1ChatQueryStreamPost$Response(params: StreamQueryApiV1ChatQueryStreamPost$Params, context?: HttpContext): Observable<StreamEvent> {
    return streamQueryApiV1ChatQueryStreamPost(this.http, this.rootUrl, params, context);
  }

  /**
   * Stream Query.
   *
   * Stream query processing for real-time feedback
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `streamQueryApiV1ChatQueryStreamPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  streamQueryApiV1ChatQueryStreamPost(params: StreamQueryApiV1ChatQueryStreamPost$Params, context?: HttpContext): Observable<StreamEvent> {
    return this.streamQueryApiV1ChatQueryStreamPost$Response(params, context)
  }

}
